const PlanOptionService = {

    _jaw: "none",
    _steps: [],
    rootCount: 0,
    crownCount: 0,
    _implantStep: null,
    _crownStep: null,
    _bridgeStep: null,
    _veneerStep: null,

    _filterStepsByJaw() {
        return this._steps.filter((step) => step.jaw === this._jaw);
    },

    getOptions(region, steps, treatment) {
        if (typeof steps === "undefined" || typeof steps !== "object" || steps === null) throw new Error("Missing or invalid param: steps");

        this.rootCount = 0;
        this.crownCount = 0;
        // this._implantStep = null;
        // this._crownStep = null;
        // this._bridgeStep = null;
        // this._veneerStep = null;

        this._implantSteps = [];
        this._crownSteps = [];
        this._bridgeSteps = [];
        this._veneerSteps = [];

        const jaw = region < 3 ? "upper" : "lower";
        this._jaw = jaw;
        this._steps = this._filterStepsByJaw(steps);

        // Get implant options
        // this._implantStep = this._getTreatmentByPid(11);
        // if (this._implantStep === null) this._implantStep = this._getTreatmentByPid(10);
        this._implantSteps = this._getTreatmentsByPid(11);
        if (this._implantSteps.length === 0) this._implantSteps = this._getTreatmentsByPid(10);

        // Get temp crown/bridge options
        this.crownCount = 0;
        // this._crownStep = this._getTreatmentByPid(9);
        // this.crownCount += this._crownStep === null ? 0 : this._crownStep.amount;
        // this._bridgeStep = this._getTreatmentByPid(15);
        // this.crownCount += this._bridgeStep === null ? 0 : this._bridgeStep.amount;
        this._crownSteps = this._getTreatmentsByPid(9);
        this.crownCount += this._crownSteps.length === 0 ? 0 : this._crownSteps.reduce((cnt, s) => { return cnt + s.amount; }, 0);
        this._bridgeSteps = this._getTreatmentsByPid(15);
        this.crownCount += this._bridgeSteps.length === 0 ? 0 : this._bridgeSteps.reduce((cnt, s) => { return cnt + s.amount; }, 0);

        // Get veneer options
        // if (this._implantStep === null) this._veneerStep = this._getTreatmentByPid(26);
        if (this._implantSteps.length === 0) this._veneerSteps = this._getTreatmentsByPid(26);

        // Get temp crown options
        // if (this.crownCount > 0 && this._implantStep === null && this._veneerStep === null) this._implantStep = this._getTreatmentByPid(315);
        if (this.crownCount > 0 && this._implantSteps.length === 0 && this._veneerSteps.length === 0) this._implantSteps = this._getTreatmentsByPid(315);

        // if (this._bridgeStep === null) {
        //     const s = this._getPrimaryTreatment();
        //     if (s!==null && s.tpl === "full_dentures") {
        //         this._bridgeStep = s;
        //         this.crownCount += this._bridgeStep.amount;
        //     }
        // }
        if (this._bridgeSteps.length === 0) {
            const s = this._getPrimaryTreatment();
            if (s!==null && s.tpl === "full_dentures") {
                this._bridgeSteps = [s];
                this.crownCount += s.amount;
            }
        }

        // this.rootCount = this._implantStep === null ? 0 : this._implantStep.amount;
        this.rootCount = this._implantSteps.length === 0 ? 0 : this._implantSteps.reduce((cnt, s) => { return cnt + s.amount; }, 0);

        const options = [];

        // if (this.rootCount) {
        //     options.push({
        //         amount: this.rootCount,
        //         pid: this._implantStep.state_pid,
        //         options: this._implantStep.options,
        //         steps: [this._implantStep],
        //     });
        // }
        if (this.rootCount) {
            options.push({
                amount: this.rootCount,
                pid: this._implantSteps[0].state_pid,
                options: this._implantSteps[0].options,
                steps: this._implantSteps,
            });
        }

        // if (this._veneerStep !== null) {
        //     options.push({
        //         amount: this._veneerStep.amount,
        //         pid: this._veneerStep.state_pid,
        //         options: this._veneerStep.options,
        //         steps: [this._veneerStep],
        //     });
        // }
        if (this._veneerSteps.length !== 0) {
            options.push({
                amount: this._veneerSteps[0].amount, // @TODO
                pid: this._veneerSteps[0].state_pid,
                options: this._veneerSteps[0].options,
                steps: this._veneerSteps,
            });
        }

        // if (this.crownCount) {
        //     options.push({
        //         amount: this.crownCount,
        //         pid: 9,
        //         options: this._crownStep !== null ? this._crownStep.options : this._bridgeStep.options,
        //         steps: [
        //             this._crownStep,
        //             this._bridgeStep,
        //         ],
        //     });
        // }
        if (this.crownCount) {
            options.push({
                amount: this.crownCount,
                pid: 9,
                crownCount: this._crownSteps.length,
                bridgeCount: this._bridgeSteps.length,
                options: this._crownSteps.length > 0 ? this._crownSteps[0].options : this._bridgeSteps[0].options,
                steps: [
                    ...this._crownSteps,
                    ...this._bridgeSteps,
                ],
            });
        }

        return options;



    },

    _getPrimaryTreatment() {
        for (const i in this._steps) {
            if (typeof this._steps[i].primary !== "undefined" && parseInt(this._steps[i].primary) === 1 && !this._steps[i].disable_options) return this._steps[i];
        }
        return null;
    },

    _getTreatmentByPid(pid) {
        pid = parseInt(pid);
        for (const i in this._steps) {
            if (parseInt(this._steps[i].state_pid) === pid && !this._steps[i].disable_options) return this._steps[i];
        }
        return null;
    },

    _getTreatmentsByPid(pid) {
        pid = parseInt(pid);
        return this._steps.filter((step) => {
        	if (step.tooth_id === "0" || step.tooth_id === "") return false;
            return parseInt(step.state_pid) === pid && !step.disable_options;
        });
    },

    _groupedSteps: {
        "0": {},
        "9": {},
        "10": {},
        "11": {},
        "15": {},
    },
    _combinations: [],

    getOptions2(steps, jaw) {
        this.jaw = "none";
        this._steps = [];
        if (typeof steps === "undefined" || typeof steps !== "object" || steps === null) throw new Error("Missing or invalid param: steps");
        if (typeof jaw !== "string" || !["upper", "lower"].includes(jaw)) throw new Error("Missing or invalid param: jaw");

        //this._steps = Array.from(steps, (obj) => Object.assign({}, obj)); // Create deep copy of input steps
        this._steps = steps;
        this._jaw = jaw;

        this._steps = this._filterStepsByJaw();

        // 2 get steps with options, merge optional steps by type
        this._groupStepsByOptions();

        return this._groupedSteps;

        // @TODO: ideiglenes híd
    },

    _filterStepsByJaw(steps) {
        return steps.filter((step) => step.jaw === this._jaw);
    },

    _groupStepsByOptions() {
        this._groupedSteps = {
            "0": {},
            "9": {},
            "10": {},
            "11": {},
            "15": {},
        };
        const groups = Object.keys(this._groupedSteps);
        this._tmpCombinations = [];
        this._steps.forEach((step) => {
            if (typeof step.parent_id === "undefined" || step.parent_id === null) {
                if (typeof this._groupedSteps["0"][String(step.state_id)] === 'undefined') this._groupedSteps["0"][String(step.state_id)] = {
                    total: 0,
                    selected: 1,
                    steps: [],
                    title: step.title,
                };
                return this._groupedSteps["0"][String(step.state_id)].steps.push(step);
            }
            let pid = String(step.state_pid);
            if (groups.includes(pid) && step.parent_id !== step.id) {
                if (typeof this._groupedSteps[pid][String(step.state_id)] === 'undefined') this._groupedSteps[pid][String(step.state_id)] = {
                    total: 0,
                    selected: step.selected,
                    steps: [],
                    title: step.title,
                };

                this._groupedSteps[pid][String(step.state_id)].steps.push(step);
            }
        });
        return this._groupedSteps;
    },

    _sumNormalSteps() {
        let total = 0;
        let ids = Object.keys(this._groupedSteps['0']);
        ids.forEach((id)=>{
            this._groupedSteps['0'][String(id)].forEach((step) => {
                total += step.price;
            });
        });
        return total;
    },

    _buildCombinations() {
        this._combinations = [];
        this._tmpCombinations = [];
        this._addCombinations(10);
        this._addCombinations(11);
        this._addCombinations(15);
        this._addCombinations(9);

        if (this._tmpCombinations.length > 4) this._tmpCombinations = this._tmpCombinations.slice(0, 4).reverse().concat(this._tmpCombinations.slice(4, this._tmpCombinations.length));

        this._tmpCombinations.forEach((c) => {
            let title = [];
            let price = 0;
            let steps = [];
            c.forEach((items) => {
                title.push(items[0].title);
                items.forEach((item) => {
                    steps.push(item);
                    price += item.price;
                });
            });
            this._combinations.push({
                title: title.join(" + "),
                price: price,
                steps: steps,
            });
        });
        return this._combinations;
    },

    _addCombinations(pid) {
        if (typeof this._tmpCombinations === 'undefined') this._tmpCombinations = [];
        if (Object.keys(this._groupedSteps[String(pid)]).length === 0) return this._tmpCombinations;
        const base = JSON.parse(JSON.stringify(this._tmpCombinations));
        this._tmpCombinations = [];

        let ids = Object.keys(this._groupedSteps[String(pid)]);
        ids.forEach((id, i)=>{
            const els = this._groupedSteps[String(pid)][String(id)];
            if (base.length === 0) {
                this._tmpCombinations.push(els);
            } else {
                base.forEach((b, j) => {
                    let baseClone = JSON.parse(JSON.stringify(b));
                    let newEls = [];
                    newEls.push(baseClone);
                    newEls.push(els);
                    if (i<2 && j<2) this._tmpCombinations.unshift(newEls);
                    else this._tmpCombinations.push(newEls);
                });
            }
        });
        return this._tmpCombinations;
    },


};

export default PlanOptionService;
